/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_TranscribingInputs */

const en_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcribing media...`)
};

const fr_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription du média...`)
};

const de_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien werden transkribiert...`)
};

const it_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione media in corso...`)
};

const ru_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрибация медиа...`)
};

const es_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcribiendo medios...`)
};

const zh_cn2_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在转写媒体...`)
};

const ja_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアを文字起こししています...`)
};

const hi_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया ट्रांसक्राइब हो रहा है...`)
};

const pt_pt2_offline_sync_status_transcribing = /** @type {(inputs: Offline_Sync_Status_TranscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A transcrever multimédia...`)
};

/**
* | output |
* | --- |
* | "Transcribing media..." |
*
* @param {Offline_Sync_Status_TranscribingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_transcribing = /** @type {((inputs?: Offline_Sync_Status_TranscribingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_TranscribingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_status_transcribing(inputs)
	if (locale === "de") return de_offline_sync_status_transcribing(inputs)
	if (locale === "it") return it_offline_sync_status_transcribing(inputs)
	if (locale === "ru") return ru_offline_sync_status_transcribing(inputs)
	if (locale === "es") return es_offline_sync_status_transcribing(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_status_transcribing(inputs)
	if (locale === "ja") return ja_offline_sync_status_transcribing(inputs)
	if (locale === "hi") return hi_offline_sync_status_transcribing(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_status_transcribing(inputs)
	return en_offline_sync_status_transcribing(inputs)
});